import Image from 'components/Image'
import cn from 'classnames'
import sortBy from 'lodash/sortBy'
import replaceCategoryVariables from 'components/pages/CateringPage/replaceCategoryVariables'

import { CateringFoodTypeQuery } from '../types/query'

type Props = {
  foodTypePage: NonNullable<CateringFoodTypeQuery['foodTypePage']>
  market?: {
    name: string
    state: string
  } | null
}

const ContentSections = ({ foodTypePage, market }: Props) => {
  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto py-24 px-4 sm:px-6 lg:px-8 text-center flex flex-col gap-y-28">
        {sortBy(foodTypePage.contentSections, 'position').map((section, i) => (
          <div
            key={`section-${section.id}`}
            className={cn(
              'flex flex-col lg:flex-row gap-y-2 md:gap-x-12 md:gap-y-0',
              {
                'lg:flex-row': i % 2 === 0,
                'lg:flex-row-reverse': i % 2 !== 0
              }
            )}
          >
            <div
              className="prose lg:prose-lg flex-grow lg:w-1/2 max-w-full text-justify"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: replaceCategoryVariables({
                  text: section.content.html,
                  market: market?.name
                })
              }}
            />
            {section.image?.url && (
              <div className="flex-grow rounded-md lg:w-1/2 max-w-full relative h-[500px]">
                <Image
                  alt={section.imageAlt || `${foodTypePage.name} catering`}
                  className="rounded-3xl bg-center object-cover"
                  layout="fill"
                  src={section.image?.url}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ContentSections
